<template>
  <div class="header-companies__item">
    <div class="header-companies__logo">
      <img
        v-if="company.companyCard.logo"
        :alt="company.companyCard.name"
        class="header-companies__logo__image"
        loading="lazy"
        :src="company.companyCard.logo"
      />
      <i
        v-else
        class="header-companies__logo__placeholder fa-regular fa-building"
      />
    </div>
    <span class="header-companies__name">{{ company.companyCard.name }}</span>
    <HeaderCompanyRating
      class="header-companies__rating"
      :model-value="company.companyCard.reviews?.average ?? null"
    />
  </div>
</template>

<script setup lang="ts">
import type { CompanyCardCompany } from "~/features/company-wall/api/localSearch.api.ts";

import HeaderCompanyRating from "./HeaderCompanyRating.vue";

defineProps<{
  company: CompanyCardCompany;
}>();
</script>
